import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, renderDateViewCalendar } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderDigitalClockTimeView } from "@mui/x-date-pickers/timeViewRenderers";
import calIco from "../assets/calendarIcon.svg";
import dayjs from "dayjs";

import "./datepicker.css";

function CalendarIcon() {
  return <img src={calIco} alt="Date picker opening icon" width={18} />;
}
export default function BasicDateTimePicker({ onChange, value, selectDay }) {
  // Function to get the index of the selected day (e.g., Monday = 1)
  const getDayIndex = (dayName) => {
    return [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ].indexOf(dayName);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DateTimePicker"]}>
        {/* <DatePicker
          value={value}
          onChange={(v) => onChange(v)}
          className="datePicker" 
          disablePast
          slotProps={{
            inputAdornment: {
              position: 'start',
            },
          }}
          slots={{
            openPickerIcon: CalendarIcon
          }}
          formatDensity="spacious"
        /> */}
        <DateTimePicker
          disablePast
          closeOnSelect={false}
          sx={{background:"none !important"}}
            
          value={value}
          onChange={(v) => onChange(v)}
          slotProps={{
            inputAdornment: {
              position: "start",
            },
            textField: {
              disabled:true,
              placeholder: "Date Time", // Placeholder text
              InputLabelProps: { shrink: false }, // Keeps the placeholder visible
            },
            popper: {
              sx: {
                '& .MuiPaper-root': {
                  width: 'auto', // Set width of the calendar popup
                  maxHeight: '380px', // Set max height if needed
                  overflowY: 'auto', // Enable scrolling if content exceeds height
                },
              },
            },
          }}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          formatDensity="spacious"
          shouldDisableDate={(date) => {
            // Only enable specific day if `selectDay.value` has a value
            if (!selectDay.value) {
              return false; // Enable all dates if no specific day is selected
            }
            const targetDayIndex = getDayIndex(selectDay.value);
            return dayjs(date).day() !== targetDayIndex;
          }}
          timeSteps={{minutes:15}} 
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
